import React from "react";
import Heading from "../ui/Heading";
import { Container, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { isMobile } from "react-device-detect";
import Ring from "../Assets/img/category/ring-category.webp";
import Bracelet from "../Assets/img/category/bracelets-category.webp";
import Earring from "../Assets/img/category/earring-category.webp";
import Necklace from "../Assets/img/category/neckless-category.webp";
import Pendants from "../Assets/img/category/pendants-category.webp";
import Diamonds from "../Assets/img/category/diamonds-category.webp";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import LeftIcon from "../Assets/img/left.svg"
import RightIcon from "../Assets/img/right.svg"
// Data Array for Categories
const categories = [
  { title: "RINGS", link: "/jewelry/fashion-rings", img: Ring },
  { title: "PENDANTS", link: "/jewelry/pendants", img: Pendants },
  { title: "EARRINGS", link: "/jewelry/earrings", img: Earring },
  { title: "BRACELETS", link: "/jewelry/bracelets", img: Bracelet },
  { title: "NECKLACES", link: "/jewelry/necklaces", img: Necklace },
  { title: "DIAMONDS", link: "/diamonds", img: Diamonds },
];

const ExploreCollection = () => {
  // Slider settings
  const sliderSettings = {
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: <img src={LeftIcon} alt={"left"} />,
    nextArrow: <img src={RightIcon} alt={"right"} />,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section className="explore-collection section-space">
      <Container fluid className="showcase-container">
        <Heading>
          <h2>SHOP BY CATEGORY</h2>
          <p>Find exactly what you need.</p>
        </Heading>


        {!isMobile ? (
          <div className="box-container mx-1440">
            {categories.map((category, index) => (
              <div className="box" key={index}>
                <div className="item text-center">
                  <Link to={category.link} className="img-box">
                    <Image src={category.img} alt={category.title} />
                  </Link>
                  <Link to={category.link}>
                    <button>{category.title}</button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <Slider {...sliderSettings}>
            {categories.map((category, index) => (
              <div className="box" key={index}>
                <div className="item text-center">
                  <Link to={category.link} className="img-box">
                    <Image src={category.img} alt={category.title} />
                  </Link>
                  <Link to={category.link}>
                    <button>{category.title}</button>
                  </Link>
                </div>
              </div>
            ))}
          </Slider>
        )}
      </Container>
    </section>
  );
};

export default ExploreCollection;
